import { JottingType, NoteBody } from '../types'

export const getNewNoteContent = (
  title = 'New note',
  body = [{ type: JottingType.P, data: '' }]
): { title: string; body: NoteBody } => ({
  title,
  body,
})
